<div class="relative">
  <input
    class="focus:border-primary h-10 w-full rounded-full border border-neutral-300 bg-white px-4 pl-10 text-base leading-normal font-normal text-primary-text focus:outline-none"
    [placeholder]="placeholder()"
    [value]="searchTermValue"
    (input)="handleSearchInput($event)"
    (keydown)="handleKeyDown($event)"
    type="text"
  />
  <img
    class="absolute top-1/2 left-4 h-4 w-4 -translate-y-1/2 transform"
    [src]="searchIconPath()"
    alt="Search Icon"
  />

  <!-- Clear button -->
  @if (searchTermValue) {
    <button
      class="group absolute top-1/2 right-3 -translate-y-1/2 transform rounded-full p-1 transition-colors duration-200 hover:bg-neutral-100"
      (click)="clearSearch()"
      aria-label="Clear search"
    >
      <svg
        class="h-4 w-4 text-neutral-500 transition-colors duration-200 group-hover:text-neutral-700"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  }
</div>
